import { PropsWithChildren, useMemo } from 'react'

import { FormGridProps } from '../FormGrid/interface'
import { FormItem } from '../FormItem'
import { FormLayoutProps } from '../FormLayout/interface'
import { SchemaForm } from '../SchemaForm'
import { SchemaItem } from '../SchemaForm/interface'

import { SchemaSearchProps } from './interface'

const resolveSchemaItems = (
  schema: SchemaSearchProps['schema']
): SchemaItem[] => {
  return schema.map(item =>
    item.type === 'void'
      ? item
      : {
          ...item,
          'x-decorator': FormItem,
          'x-decorator-props': {
            gridSpan: item.gridSpan,
            feedbackLayout: 'none'
          }
        }
  )
}

const defaultGrid: FormGridProps = {
  rowGap: 16,
  columnGap: 16,
  minWidth: 120,
  maxWidth: 400,
  // auto fit
  columns: undefined
}

const defaultLayout: FormLayoutProps = {
  wrapperMinWidth: 200
}

export const SchemaSearch = ({
  schema,
  grid,
  layout,
  ...restProps
}: PropsWithChildren<SchemaSearchProps>) => {
  const schemaItems = useMemo(() => resolveSchemaItems(schema), [schema])

  return (
    <SchemaForm
      {...restProps}
      schema={schemaItems}
      grid={{
        ...defaultGrid,
        ...grid
      }}
      layout={{
        ...defaultLayout,
        ...layout
      }}
    />
  )
}
